import {useState, useEffect} from 'react';
import styled from '@emotion/styled';

import { ActionButton } from '../../Common';

import { Tooltip, Popover, IconButton } from '@mui/material';

import useTableStore from '../../../store/table';

// context
import { useTableId } from '../../../contexts/TableId';

import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';

const Draggable = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  min-width: 18rem;
`;

const DragContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
  gap: 1.5rem;
  padding: .6rem 1rem;
`;

const DragHandle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  /* padding: 1rem .3rem; */
  align-self: stretch;
  background-color: ${props => props.theme.colors.darkBg};
  border-right: 1px solid ${props => props.theme.colors.border};
`;


const ColumnsComponent = ({headers = []}) => {
  const tableId = useTableId();
  const storedTableColumns = useTableStore(state => state.tableColumnSort[tableId]) || headers.map(el => {
    el.active = true;
    return el;
  });

  const updateTableColumns = useTableStore(state => state.setSortedColumns);

  const [draggedIndex, setDraggedIndex] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  /* Draggable functions */
  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (index) => {
    if (draggedIndex === index) return;
    const reorderedColumns = [...storedTableColumns];
    const [removed] = reorderedColumns.splice(draggedIndex, 1);
    reorderedColumns.splice(index, 0, removed);
    setDraggedIndex(index);
    updateTableColumns(tableId, reorderedColumns);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  /* End Draggable Functions */

  const toggleColumn = (index) => {
    let newColumns = storedTableColumns.map((column, i) => {
      if (i === index) {
        // Create a new object with the updated active property
        return { ...column, active: !column.active };
      }
      return column;
    });
    updateTableColumns(tableId, newColumns);
  }

  return (
    <>
    <Tooltip title="Sort Columns">
      <ActionButton color="icon" variant="outlined" onClick={handleClick}><DragIndicatorRoundedIcon /></ActionButton>
    </Tooltip>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div>
          {storedTableColumns.map(({label, active}, index) => (
            <Draggable 
              key={label} 
              draggable="true"
              onDragStart={() => handleDragStart(index)}
              onDragOver={(e) => {
                e.preventDefault();
                handleDragOver(index)
              }}
              onDragEnd={handleDragEnd}
              >
              <DragHandle><DragIndicatorRoundedIcon color="basic" /></DragHandle>
              <DragContent>{label}
                <IconButton size="small" onClick={() => toggleColumn(index)}>
                  {active ? <VisibilityRoundedIcon color="primary" /> : <VisibilityOffRoundedIcon />}
                </IconButton>
                </DragContent> 
            </Draggable>
          ))}
        </div>
      </Popover>
    </>
  )
};

export default ColumnsComponent;